module.exports = __webpack_public_path__ + "7fee2ee0398e8515745d18bdf223e356.svg";